import React from "react";
import { FiGlobe, FiUploadCloud, FiCpu } from "react-icons/fi";

const ImageSourceSelector = ({
  imageSource,
  setImageSource,
  disabled,
  allowNoImage,
  setAllowNoImage,
}) => {
  const sources = [
    {
      id: "internet",
      label: "Internet",
      icon: <FiGlobe className="mr-2" />,
      description: "Tìm kiếm ảnh từ internet phù hợp với nội dung bài viết",
    },
    {
      id: "ai",
      label: "AI",
      icon: <FiCpu className="mr-2" />,
      description: "Tạo ảnh bằng AI dựa trên nội dung bài viết",
    },
    {
      id: "upload",
      label: "Thiết bị",
      icon: <FiUploadCloud className="mr-2" />,
      description: "Tải lên ảnh từ thiết bị của bạn",
    },
  ];

  return (
    <div className="mb-6">
      <div className="flex justify-between items-center mb-2">
        <label className="block text-gray-700 font-medium">
          Chọn nguồn ảnh
        </label>
        <div className="flex items-center">
          <label className="text-gray-700 mr-2 text-sm">Không dùng ảnh</label>
          <div className="relative inline-block w-12 align-middle select-none">
            <input
              type="checkbox"
              name="allowNoImage"
              id="allowNoImage"
              checked={allowNoImage}
              onChange={(e) => setAllowNoImage(e.target.checked)}
              className="hidden"
            />
            <label
              htmlFor="allowNoImage"
              className={`block overflow-hidden h-6 rounded-full cursor-pointer transition-colors duration-200 ease-in-out
                ${allowNoImage ? "bg-blue-600" : "bg-gray-300"}`}
            >
              <span
                className={`block h-6 w-6 rounded-full shadow transform transition-transform duration-200 ease-in-out
                  ${
                    allowNoImage
                      ? "translate-x-6 bg-white"
                      : "translate-x-0 bg-white"
                  }`}
              />
            </label>
          </div>
        </div>
      </div>
      <div
        className={`grid grid-cols-1 md:grid-cols-3 gap-3 ${
          allowNoImage ? "opacity-50 pointer-events-none" : ""
        }`}
      >
        {sources.map((source) => (
          <div
            key={source.id}
            onClick={() => !disabled && setImageSource(source.id)}
            className={`border rounded-md p-3 cursor-pointer flex flex-col transition-colors ${
              imageSource === source.id
                ? "border-blue-500 bg-blue-50"
                : "border-gray-300 hover:border-blue-300 hover:bg-blue-50"
            } ${disabled ? "opacity-50 pointer-events-none" : ""}`}
          >
            <div className="flex items-center mb-2">
              <div
                className={`flex items-center justify-center ${
                  imageSource === source.id ? "text-blue-600" : "text-gray-600"
                }`}
              >
                {source.icon}
                <span className="font-medium">{source.label}</span>
              </div>
              <div className="ml-auto">
                <input
                  type="radio"
                  name="imageSource"
                  checked={imageSource === source.id}
                  onChange={() => !disabled && setImageSource(source.id)}
                  className="text-blue-600 focus:ring-blue-500"
                  disabled={disabled}
                />
              </div>
            </div>
            <p className="text-sm text-gray-600">{source.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageSourceSelector;
